exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PageHeader {\n  background: #fff;\n  padding-top: 0;\n  border-bottom: 1px solid #000;\n  padding-top: 16px; }\n  .PageHeader h1 {\n    margin-bottom: 0; }\n  .PageHeader-buttons {\n    padding: 12px 0;\n    display: -ms-flexbox;\n    display: flex; }\n    .PageHeader-buttons > button,\n    .PageHeader-buttons > a {\n      margin-right: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PageHeader/PageHeader.scss
// module id = 1460
// module chunks = 0